// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"d556bb6e","900":"6ad1fe45"}[chunkId] + ".chunk.js";
};